import { IAbstractRecord } from '@models';
import { IDefaultCommissionInfo, IDefaultCommissionLovs } from '.';
import {
  enumListAsRecordObject,
  lookupListAsRecordObject,
} from '@utils/graph-utils';

export const mapToDrawerData: (data: IAbstractRecord) => {
  lovs: IDefaultCommissionLovs;
  data: IDefaultCommissionInfo;
} = (data: IAbstractRecord) => {
  const lovs: IDefaultCommissionLovs = {
    applicableOn: lookupListAsRecordObject(
      data.Core.lookups.commissionApplicableOnOptions
    ),
    commissionType: enumListAsRecordObject(
      data.Core_CommissionTypes.enumValues
    ),
  };

  const businessPartnerLine =
    data?.SalesforceManagement?.entities?.businessPartnerLine?.views
      ?.SalesforceManagement_all?.properties;

  const mappedData: IDefaultCommissionInfo = {
    assignedLineName:
      businessPartnerLine?.LineID?.views?.PlanConfigManagement_all?.properties
        ?.Name,
    commissionType: businessPartnerLine?.LineCommissionType,
    lineCommissionValue: businessPartnerLine?.LineCommissionValue,
    valueCurrency: businessPartnerLine?.ValueCurrency?.Id,
    lineCommissionRate: businessPartnerLine?.LineCommissionRate,
    applicableOn: businessPartnerLine?.ApplicableOn?.Id,
  };

  return {
    lovs,
    data: mappedData,
  };
};
